import { FaInfoCircle } from "react-icons/fa";
import React from "react";

const InfoTooltip = ({ title, text }) => {
  return (
    <section className="relative inline-block group cursor-pointer">
      <div className="center">
        <div className="animate-ping absolute border border-white rounded-full h-4 w-4" />
        <FaInfoCircle className="text-xl cursor-pointer" />
      </div>

      {/* Tooltip */}
      <div className="absolute left-0 top-8 bg-black bg-opacity-90 text-white text-sm rounded-lg p-3 w-72 shadow-lg invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 pointer-events-none">
        <h3 className="font-bold mb-1">{title}</h3>
        <p>{text}</p>
      </div>
    </section>
  );
};

export default InfoTooltip;
